// extracted by mini-css-extract-plugin
module.exports = {"projects":"Projects_projects__2mnM3","section-title":"Projects_section-title__1ti0C"};